<template>

  <a class="card" :href="movie.link">
		<div class="img-wrapper">
			<img
			:src="thumbnailUrl"
			class="card-img-top">
		</div>

		<div class="card-body">
			<a :href="movie.link">
				<h5 class="card-title text-start">
					<span v-html="highlightedPostTitle || movie.title.rendered" />
				</h5>
			</a>
			<div class="buttons-wrapper">
				<a class="button" :href="movie.link">
					{{ lang=='he-IL'? 'קראו עוד':'Read more' }}
				</a>
				<a v-if="movie.custom_fields.trailer" class="button" target="_blank" :href="movie.link+'#trailer'">
					{{ lang=='he-IL'? 'צפו בטריילר':'Watch trailer' }}
				</a>
			</div>
    </div><!-- .card-body -->
  </a><!-- .card -->

</template>

<script>
export default {
	props: {
		movie: {
			type: Object,
			required: true,
			default: null
		},
		searchTerm: {
			type: String,
			required: false,
			default: null
		}
	},
	data() {
		return {
			lang: 'he-IL'
		}
	},
	computed: {

		// highlight the search term in post titles.
		highlightedPostTitle() {
			if ( this.searchTerm ) {
				return this.highlightData( this.movie.title.rendered );
			}
		},

		// highlight the search term in post excerpts.
		highlightedPostExcerpt() {
			if ( this.searchTerm ) {
				return this.highlightData( this.movie.excerpt.rendered );
			}
		},

		thumbnailUrl() {
			return this.movie.featured_image_url && this.movie.featured_image_url
		}

	},
	methods: {

		// add span tags with the hl-search CSS class to the search term.
		highlightData( data ) {
			if ( this.searchTerm ) {
				const pattern = new RegExp( this.searchTerm, 'i' );
				const highlightedData = data.replace(
					pattern,
					`<span class="hl-search">${this.searchTerm}</span>`
				);
				return highlightedData;
			}
		}
	},
	mounted() {
		this.lang = document.getElementsByTagName('html')[0].getAttribute('lang')
	}
};
</script>

<style>
.card {
	min-width: 23%;
	max-width: 23%;
	border: none;
	background: transparent;
	cursor: pointer;
}

a:hover {
	text-decoration: none !important;
}

.card-body {
	padding: 0.4em;
}

.card .img-wrapper {
	overflow: hidden;
	border: 1px solid black;
}

.card-img-top {
	/* height: 15vw; */
	object-fit: cover;
	aspect-ratio: 16/9;
	transform: scale(1.01);
	transition: 400ms ease-out;
}

.card:hover .card-img-top {
	transform: scale(1.08);
}

.card .hl-search {
	background-color: yellow;
}

.card .buttons-wrapper {
	display: flex;
	justify-content: space-evenly;
}

.card a.button {
	position: relative;
	font-weight: 400;
	cursor: pointer;
	padding: 0.1em 0.5em;
	font-size: 0.9em;
	box-shadow: 0px 3px 6px #00000080;
	border: 2px solid #000000;
	color: black;
	background-color: white;
	min-width: 40%;
	text-align: center;
	opacity: 0;
	pointer-events: none;
	transition: 300ms;
}

.card a.button:nth-child(2) {
	color: white;
	background-color: black;
}

.card a.button:hover {
	background: white;
	bottom: 1px;
	text-decoration: none;
}

.card a.button:nth-child(2):hover {
	background: black;
}

.card:hover a.button {
	opacity: 1;
	pointer-events: all;
}

@media only screen and (max-width: 768px) {
	.card {
		max-width: 50%;
	}
}

@media only screen and (max-width: 480px) {
	.card {
		min-width: 100%;
	}
}
</style>

